import { auth } from '../index';

export * from './methods'; 

export const getAuthToken = async () => {
  const currentUser = auth.currentUser;
  if (currentUser) {
    return currentUser.getIdToken(true);
  }
  return null;
}; 